
<template>
  <div id="app-container" :class="{ 'layout-split': auth.isAuthenticated }">
    
    <!-- Sidebar: shown only if authenticated -->
    <aside v-if="auth.isAuthenticated" class="sidebar">
      <h1 class="logo">Tamarys</h1>
      <nav>
        <router-link to="/">Dashboard</router-link>
        <router-link to="/atenciones">Atenciones</router-link>
        <router-link to="/daily-report">Reporte Diario</router-link>
        <router-link to="/clients">Clientes</router-link>
        <router-link to="/manicuristas">Manicuristas</router-link>
        <router-link to="/products">Productos</router-link>
      </nav>
      <div class="user-info">
        <span>Hola, {{ auth.user?.nombre || 'Usuario' }}</span>
        <button @click="handleLogout" class="logout-button">Cerrar Sesión</button>
      </div>
    </aside>

    <!-- Main Content Area: always present -->
    <main class="content">
      <router-view/>
    </main>

  </div>
</template>

<script setup>
import { inject } from 'vue';
import { useRouter } from 'vue-router';
import axios from 'axios';

const auth = inject('auth');
const router = useRouter();

const handleLogout = async () => {
  try {
    await axios.post('/api/logout');
  } catch (error) {
    console.error('Error during logout:', error);
  } finally {
    auth.logout();
    router.push('/login');
  }
};
</script>

<style>
/* Global styles */
body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  background-color: #f8f9fa;
}

#app-container {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

/* Layout for the authenticated state */
.layout-split {
  display: flex;
}

.sidebar {
  width: 240px;
  background-color: #343a40;
  color: white;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 20px;
  flex-shrink: 0; /* Prevent sidebar from shrinking */
}

.logo {
  text-align: center;
  font-size: 24px;
  margin-bottom: 30px;
  color: #f8f9fa;
}

.sidebar nav {
  display: flex;
  flex-direction: column;
}

.sidebar nav a {
  color: #adb5bd;
  text-decoration: none;
  padding: 12px 15px;
  border-radius: 4px;
  margin-bottom: 8px;
  font-weight: 500;
  transition: background-color 0.2s, color 0.2s;
}

.sidebar nav a:hover {
  background-color: #495057;
  color: white;
}

.sidebar nav a.router-link-exact-active {
  background-color: #007bff;
  color: white;
}

.user-info {
  margin-top: auto;
  text-align: center;
}

.user-info span {
  display: block;
  margin-bottom: 12px;
  font-size: 14px;
}

.logout-button {
  background: #dc3545;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  width: 100%;
  transition: background-color 0.2s;
}

.logout-button:hover {
  background: #c82333;
}

.content {
  flex-grow: 1;
  padding: 40px;
  overflow-y: auto;
  /* The login page will be centered by its own styles */
}
</style>
